import { IStore } from '../../index'

export function getRequestStatus(state: IStore) {
  return state.events.pdfRequest
}

export function getEventPdf(state: IStore) {
  return state.events.pdf
}

export function getEventPdfId(state: IStore) {
  return state.events.eventId
}
